export const almanacFileKeys = {
  prefix: 'almanacFiles',
  detail: (key: string) => [almanacFileKeys.prefix, 'detail', key],
  update: (key: string) => [almanacFileKeys.prefix, 'update', key],
}
